import { URLParamFilter } from "src/base-components/tableColumnFilters/useFilters";
import { trackEntityAnalyticsEvent } from "src/entities/trackEntityAnalyticsEvent";
import { Environment } from "src/hooks/useEnvironment";
import {
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useTrackEntityFunnel = (entitySchemaType: string) => {
  const { orgId, workspace } = useWorkspaceContext();
  const baseProps = {
    organization_id: orgId,
    entity_schema_type: entitySchemaType,
  };

  const trackSearchExecuted = () => {
    tracker.emit(trackingEvents.entitySearchExecuted(baseProps));
  };

  const trackFilterApplied = (appliedFilters: URLParamFilter[]) => {
    tracker.emit(
      trackingEvents.entityFilterApplied({
        ...baseProps,
        // filter values may contain PII, only track key + operator
        filters: appliedFilters.map(({ key, operator }) => ({ key, operator })),
      }),
    );
  };

  const trackDetailOpened = () => {
    tracker.emit(trackingEvents.entityDetailOpened(baseProps));
  };

  const trackCreateCaseClicked = () => {
    tracker.emit(trackingEvents.entityCreateCaseClicked(baseProps));
  };

  const trackRelatedCaseDetailOpened = (env: Environment) => {
    trackEntityAnalyticsEvent(
      workspace.base_url,
      "entity_related_case_detail_opened",
      env,
    );
    tracker.emit(trackingEvents.entityRelatedCaseDetailOpened(baseProps));
  };

  const trackRelatedCaseOpened = (env: Environment) => {
    trackEntityAnalyticsEvent(
      workspace.base_url,
      "entity_related_case_opened",
      env,
    );
    tracker.emit(trackingEvents.entityRelatedCaseOpened(baseProps));
  };

  return {
    trackSearchExecuted,
    trackFilterApplied,
    trackDetailOpened,
    trackCreateCaseClicked,
    trackRelatedCaseDetailOpened,
    trackRelatedCaseOpened,
  };
};
